import { render } from "./addressForm.vue?vue&type=template&id=6f362190&ts=true"
import script from "./addressForm.vue?vue&type=script&lang=ts"
export * from "./addressForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__